<mat-sidenav-container [class]="burgerClass"  [hasBackdrop]="_hasBackdrop" [@.disabled]="_disableAnimation">
  <!--sidenav content-->
  <mat-sidenav #sidenav
    mode="over"
    (keydown.escape)="sidenav.close()"
    [position]="menuPosition"
    [autoFocus]="true"
    [fixedInViewport]="true"
                 [ngStyle]="{
                 'inset-inline-start': (menuPosition == 'start') ? '0' : null,
                 'inset-inline-end': (menuPosition == 'end') ? '0' : null
                 }">
    @if (_closeBtnInMenu) {
      <button mat-button (click)="sidenav.close()" [class]="closeBtnClasses">
        <span [class.sr-only]="_iconOnlyClose == true" translate>{{ closeBtnText }}</span>
        <i [class]="closeIconClass" ></i>
      </button>
    }
    <ng-content selector="#sidenav-content"></ng-content>
  </mat-sidenav>
  <!--/sidenav content-->
  <!--sidenav open-->
  <mat-sidenav-content>
    <button mat-button (click)="_toggleBtn ? sidenav.toggle() : sidenav.open()" [class]="openBtnClasses">
      <span [class.sr-only]="_iconOnlyOpen == true" translate>{{ openBtnText }}</span>
      <i [ngClass]="_toggleBtn && sidenav.opened ? closeIconClass : openIconClass"></i>
    </button>
  </mat-sidenav-content>
  <!--/sidenav open-->
</mat-sidenav-container>
